var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatmidGateClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09639 7L13.8735 12.7771C13.9578 12.8896 14 13.0161 14 13.1566C14 13.2972 13.9578 13.4096 13.8735 13.494L13.494 13.8735C13.4096 13.9578 13.2972 14 13.1566 14C13.0161 14 12.8896 13.9578 12.7771 13.8735L7 8.05422L1.22289 13.8735C1.11044 13.9578 0.983936 14 0.843374 14C0.702811 14 0.590361 13.9578 0.506024 13.8735L0.126506 13.494C0.0421687 13.4096 0 13.2972 0 13.1566C0 13.0161 0.0421687 12.8896 0.126506 12.7771L5.94578 7L0.126506 1.22289C0.0421687 1.11044 0 0.983936 0 0.843374C0 0.702811 0.0421687 0.590361 0.126506 0.506024L0.506024 0.126506C0.590361 0.0421687 0.702811 0 0.843374 0C0.983936 0 1.11044 0.0421687 1.22289 0.126506L7 5.90361L12.7771 0.126506C12.8896 0.0421687 13.0161 0 13.1566 0C13.2972 0 13.4096 0.0421687 13.494 0.126506L13.8735 0.506024C13.9578 0.590361 14 0.702811 14 0.843374C14 0.983936 13.9578 1.11044 13.8735 1.22289L8.09639 7Z",
    fill: "#1B358F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatmidGateClose);
export default __webpack_public_path__ + "static/media/matmid-gate-close.149203ba0dc2f2e17b8bc61c492ffd7f.svg";
export { ForwardRef as ReactComponent };